export default {
    title: 'Account data',
    firstName: {
        label: 'First name',
        required: 'Please enter your first name',
        maxLength: 'Your first name must not contain more than 64 characters.'
    },
    lastName: {
        label: 'Last name',
        required: 'Please enter your last name',
        maxLength: 'Your last name must not contain more than 64 characters.'
    },
    position: {
        label: 'Position',
        maxLength: 'Your position must not contain more than 128 characters.'
    },
    phone: {
        label: 'Phone',
        maxLength: 'Yourt phone number must not extend 64 numbers'
    },
    submit: 'Submit',
    success: 'Your account data was updated successfully'
}
